export enum FilterOption {
  NONE = 'none',
  CREATED_BY = 'created_by_id',
  MISSING_ALT = 'missing_alt',
}
